<template>
    <div id="loading_overlay" :class="[displayOverlay ? 'active' : '']">
        <img id="overlay_img" src="../../public/img/bkl_Loading.gif" alt="">
        <p id="overlay_text">
            CHARGEMENT...
        </p>
        <div id="overlay" />
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';

    export default {
        name: 'AppOverlay',
        computed: {
            ...mapGetters('app', ['displayOverlay'])
        }
    };
</script>

<style lang="scss" scoped>

    #loading_overlay {
        width: 100vw;
        height: 100vh;
        position: absolute;
        display: none;
    }

    #loading_overlay.active {
        display: block;
    }

    #overlay_img, #overlay_text {
        top: 30vh;
        position: relative;
        z-index: 100;
    }

    #overlay_img {
        width: 200px;
        height: 150px;
        background-size: cover;
        animation-duration: 2s;
        animation-name: bounce;
    }

    #overlay_text {
        color: #fff;
        font-weight: 500;
        font-size: 20px;
    }

    #overlay {
        background-color: #1A2129;
        width: 100vw;
        height: 100vh;
        position: absolute;
        z-index: 99;
        top: 0px;
        opacity: 0.8;
    }

    @keyframes bounce {
        0% {
            transform: translateY(-30px);
        }

        25% {
            transform: translateY(0px);

        }

        40% {
            transform: translateY(-10px);

        }
        65% {
            transform: translateY(0px);
        }
        80% {
            transform: translateY(-5px);

        }
        100% {
            transform: translateY(0px);
        }
    }

</style>
